import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { LINKS } from 'routes/constants'
import { ConnectorsStatsType } from 'routes/Solutions/helpers'
import clsx from 'clsx'
import classes from './SolutionNetwork.module.scss'

export const SolutionNetwork = ({
  stats,
  showAllStats,
}: {
  stats: ConnectorsStatsType
  showAllStats?: boolean
}) => {
  const { prebuildConnectors, operationsCount, dataCollectionsCount } = stats

  return (
    <div className={classes.wrapper}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Thousands of pre-built connectors out of the box
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Add your library of connectors to yours in one go. We've spent years
        building and maintaining connectors so you don't have to.
      </Text>
      <div className={classes.visual}>
        <div
          className={clsx(
            classes.content,
            showAllStats && classes.content__all,
          )}
        >
          <div className={classes.counter}>
            <div className={classes.counter_data}>
              <div className={classes.counter_number}>
                <Text as={'span'} className={classes.counter_number__base}>
                  000000
                </Text>
                <Text as={'span'} className={classes.counter_number__main}>
                  {prebuildConnectors}
                </Text>
              </div>
            </div>
            <Text
              size={'sm'}
              lh={'relaxed'}
              center
              className={classes.counter_text}
            >
              pre-built connectors
            </Text>
          </div>
          {showAllStats && (
            <div className={classes.counter}>
              <div className={classes.counter_data}>
                <div className={classes.counter_number}>
                  <Text as={'span'} className={classes.counter_number__base}>
                    000000
                  </Text>
                  <Text as={'span'} className={classes.counter_number__main}>
                    {operationsCount}
                  </Text>
                </div>
              </div>
              <Text
                size={'sm'}
                lh={'relaxed'}
                center
                className={classes.counter_text}
              >
                pre-mapped operations
              </Text>
            </div>
          )}
          <div className={classes.counter}>
            <div className={classes.counter_data}>
              <div className={classes.counter_number}>
                <Text as={'span'} className={classes.counter_number__base}>
                  000000
                </Text>
                <Text as={'span'} className={classes.counter_number__main}>
                  {dataCollectionsCount}
                </Text>
              </div>
            </div>
            <Text
              size={'sm'}
              lh={'relaxed'}
              center
              className={classes.counter_text}
            >
              pre-mapped data collections
            </Text>
          </div>
        </div>
      </div>
      <Link
        className={classes.link}
        asPageButton
        type='secondary'
        href={LINKS.INTEGRATIONS}
      >
        Explore Supported Integrations
      </Link>
    </div>
  )
}
